import { readQueryParams } from 'src/utils/QueryParamsHelper';
import axiosInstance, { ApiKeys, getApiUrl } from '../../../utils/ApiHelper';
import { STORE_KEYS } from '../constants';
import { FeedbackHistoryPayload, RepaymentHistoryPayload } from '../interfaces/Overview.type';
import {
  setCaseDetail,
  setCaseDetailError,
  setCaseDetailLoading
} from '../reducers/caseDetailSlice';

interface dispatchProps {
  payload: any;
  type: string;
}
export const fetchFeedbackHistory = (
  lan: string,
  customerRefrenceId: string,
  feedbackHistoryPayload: FeedbackHistoryPayload = {
    size: 10,
    page: 0,
    loan_account_number: lan,
    customer_reachable: false,
    caseReferenceId: '',
    caseBusinessVertical: ''
  }
) => {
  const url = getApiUrl(ApiKeys.FETCH_FEEDBACK_HISTORY);
  return function (dispatch: ({ payload, type }: dispatchProps) => void) {
    dispatch(
      setCaseDetailLoading({
        lan,
        customerRefrenceId,
        key: STORE_KEYS.FEEDBACK_HISTORY,
        loading: true
      })
    );
    axiosInstance
      .get(url, { params: feedbackHistoryPayload })
      .then(response => {
        dispatch(
          setCaseDetail({
            lan,
            customerRefrenceId,
            key: STORE_KEYS.FEEDBACK_HISTORY,
            data: response.data
          })
        );
      })
      .catch(err => {
        dispatch(
          setCaseDetailError({
            lan,
            customerRefrenceId,
            key: STORE_KEYS.FEEDBACK_HISTORY,
            error: err
          })
        );
      });
  };
};
